import { connect }     from 'react-redux';
import { reducerType } from 'reducer';
//import Tooltip         from '@mui/material/Tooltip';
//import ttprops         from 'utils/ttprops'
import { words }       from 'utils/dictionary'
import WhatsAppIcon    from '@mui/icons-material/WhatsApp';
import { makeStyles }  from 'makeStyles';
import { useMemo }     from 'react';
import { keyframes }   from '@emotion/react';

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 4px 20px rgba(91, 193, 75, 0.4);
  }
  50% {
    box-shadow: 0 4px 30px rgba(91, 193, 75, 0.7);
  }
  100% {
    box-shadow: 0 4px 20px rgba(91, 193, 75, 0.4);
  }
`;

const useStyles = makeStyles()((Theme) => ({
    root: {
        display:         'flex',
        height:          120,
        width:           220,
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
        gap:             8,
        padding:         12,
        backgroundColor: 'rgba(91, 193, 75, 0.1)',
        borderRadius:    16,
        border:          '2px solid #5bc14b',
        boxShadow:       '0 4px 20px rgba(91, 193, 75, 0.4)',
        zIndex:          1000,
        transition:      'all 0.3s ease',
        animation:       `${pulseAnimation} 2s infinite`,
    },
    closeButton: {
        position:        'absolute',
        top:             6,
        right:           6,
        width:           24,
        height:          24,
        borderRadius:    12,
        border:          'none',
        background:      'rgba(0,0,0,0.05)',
        color:           '#333',
        fontWeight:      'bold',
        cursor:          'pointer',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        lineHeight:      1,
        transition:      'background 0.2s ease, transform 0.2s ease',
        '&:hover': {
            background: 'rgba(0,0,0,0.12)',
            transform:  'scale(1.05)',
        },
        '&:focus': {
            outline: '2px solid rgba(0,0,0,0.25)',
        },
    },
    linkContainer: {
        height:          70,
        width:           70,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        backgroundColor: '#5bc14b',
        borderRadius:    '50%',
        cursor:          'pointer',
        transition:      'all 0.3s ease',
        boxShadow:       '0 2px 10px rgba(91, 193, 75, 0.5)',
        '&:hover': {
            transform:   'scale(1.1)',
            boxShadow:   '0 4px 20px rgba(91, 193, 75, 0.8)',
            backgroundColor: '#4aa83a',
        }
    },
    link: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        width:           '100%',
        height:          '100%',
    },
    text: {
       fontWeight:      'bold',
       fontSize:         16,
       color:            '#333',
       textAlign:        'center',
       lineHeight:       1.3,
    }
  }),
);

type WhatsAppLinkType = {
    variant: string,
    lang:    string,
    onClose?: () => void,
    hidden?: boolean,
}

const WhatsAppLink: React.FC<WhatsAppLinkType> = ({ variant, lang, onClose, hidden }) => {

  const  { classes }  = useStyles();

  const rootStyle = useMemo(() => {
    if (variant === 'fixed') {
      return {
        position: 'fixed' as const,
        bottom:   20, 
        left:     20,
      }
    }

    if (variant === 'sidebar') {
      return {
        width: '100%',
        position: 'relative' as const,
        animation: 'none',
        boxShadow: 'none',
        borderRadius: 12,
        marginTop: 12,
        pointerEvents: 'auto' as const,
      }
    }

    return {}
  },[variant])

  if (hidden) {
    return null;
  }

  return (
    <div 
        className = { classes.root }
        style     = {{
          ...rootStyle,
          animation: variant === 'sidebar' ? 'none' : undefined,
        }}
    >
        {variant === 'sidebar' && onClose && (
          <button
            type="button"
            className={classes.closeButton}
            onClick={onClose}
            aria-label="Close WhatsApp helper"
          >
            X
          </button>
        )}
        <div className = { classes.linkContainer }>
            <a 
              className = { classes.link }
              href      = 'https://wa.me/972547451870'
              target    = "_blank"
              rel       = "noreferrer"
            >
              <WhatsAppIcon style = {{ fontSize: 40, color: '#FFF' }}/>
            </a>
        </div>
        <div className = { classes.text }>
           { words['yisumaticaRepHelp'][lang] } 
        </div>
    </div>
  );
}


const mapStateToProps = (reducer: reducerType) => {
  return {
    lang: reducer.components.lang,
  }};

export default connect(mapStateToProps)(WhatsAppLink);
